<template>
  <div :class="`trust-wrap trust-wrap--${getWrapModifier()}`">
    <ul class="trust-list">
      <li
        :class="`trust-list__item trust-list__item--${key} ${getActive(trust)}`"
        v-for="(trust, key) in trusts"
        :key="key"
        @click="setTrust(trust.value)"
      >
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'Trust',
    props: {
      trust: {
        type: Number
      },
    },
    data() {
      return {
        trusts: {
          negative: {
            value: -1
          },
          netural: {
            value: 0
          },
          positive: {
            value: 1
          }
        }
      };
    },
    methods: {
      setTrust(trust) {
        this.$emit('setTrust', trust);
      },
      getWrapModifier() {
        const trustKeys = Object.entries(this.trusts);
        const trust = trustKeys.find(item => item[1].value === this.trust);

        return trust[0];
      },
      getActive(trust) {
        return trust.value === this.trust ? 'trust-list__item--active' : '';
      },
    }
  };
</script>

<style>
  .trust-wrap {
    position: relative;
    z-index: 100;
  }
  .trust-list {
    display: flex;
    flex-direction: row;
    padding: 0;
    margin: 5px 0;
    margin-right: 0;
    list-style: none;
  }

  .trust-list::before {
    position: absolute;
    z-index: 0;
    top: -2px;
    background-color: #ffffff;
    box-shadow: 4px 4px 8px rgba(0, 0, 0, .1);
    border: 1px solid rgba(0, 0, 0, .1);
    border-radius: 3px;
    display: none;
    width: 100%;
    height: 100%;
    content: '';
  }

  .trust-wrap--netural:hover .trust-list{
      top: -24px;
  }
  .trust-wrap--positive:hover .trust-list{
      top: -48px
  }
  .trust-list__item {
    position: relative;
    z-index: 1;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin: 0 5px;
    cursor: pointer;
    display: none;
  }
  .trust-list__item:last-child {
    margin-bottom: 0;
  }
  .trust-list__item--negative{
    background: rgba(255, 51, 0, 0.286);
  }
  .trust-list__item--netural{
    background-color: #5e6d826f;
  }
  .trust-list__item--positive{
    background:  rgba(153, 255, 102, 0.678);
  }
  .trust-list__item--active {
    display: inline-block;
  }
  .trust-wrap:hover .trust-list__item,  .trust-wrap:hover .trust-list::before{
    display: inline-block;
  }
</style>
